import { defineComponent as _defineComponent } from 'vue'
import {
  isAuditor,
  isEmployeeOnly,
  isLead,
  isManager,
  isReviewerOrHigher,
  isSchedulingAdminOrHigher,
  isSupport,
} from "@/auth/auth.roles";
import ProfileView from "@/components/ProfileView.vue";
import { useUserStore } from "@/stores/user.store";
import { computed, ref } from "vue";
import { useRoute } from "vue-router";
import { useDisplay } from "vuetify";
import ClearBids from "./ClearBids.vue";
import ClearShifts from "./ClearShifts.vue";
import ClearWorkforce from "./ClearWorkforce.vue";
import { useCurrSchedDataIdsStore } from "@/stores/currSchedDataIds.store";
import { hasSchedulePassed } from "@/lib/schedPeriod";
import { IS_STAGING } from "@/router";
import useFeatureFlags from "@/composables/useFeatureFlags";


export default /*@__PURE__*/_defineComponent({
  __name: 'NavigationView',
  setup(__props, { expose: __expose }) {
  __expose();

const { isVacationUploadsEnabled } = useFeatureFlags();

const currSchedDataIdsStore = useCurrSchedDataIdsStore();
const hasCurrSchedPassed = computed(() => hasSchedulePassed(currSchedDataIdsStore.currSchedPeriodId));

const route = useRoute();

const IS_NODE_ENV_DEV = import.meta.env.DEV;

const userStore = useUserStore();
const compKey = ref(0);
const { xs: isMobileViewport } = useDisplay();

const hasLiveScheduleAccess = computed(() => {
  return (isManager() || isLead() || isSupport() || isSchedulingAdminOrHigher());
});

const __returned__ = { isVacationUploadsEnabled, currSchedDataIdsStore, hasCurrSchedPassed, route, IS_NODE_ENV_DEV, userStore, compKey, isMobileViewport, hasLiveScheduleAccess, get isAuditor() { return isAuditor }, get isEmployeeOnly() { return isEmployeeOnly }, get isReviewerOrHigher() { return isReviewerOrHigher }, get isSchedulingAdminOrHigher() { return isSchedulingAdminOrHigher }, ProfileView, ClearBids, ClearShifts, ClearWorkforce, get IS_STAGING() { return IS_STAGING } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})